import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-353c0a34"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "模板审核状态：", -1));
const _hoisted_6 = {
  style: {
    "width": "250px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "模板类型：", -1));
const _hoisted_9 = {
  style: {
    "width": "250px"
  }
};
const _hoisted_10 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = {
  key: 3
};
import { ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Search, Refresh } from '@element-plus/icons-vue';
import { useRouter, useRoute } from 'vue-router';
import SmsModule from './components/SmsModule';
import { getSmsTemplatePage, delSmsTemplate, querySmsTemplateAuditStatus, asyncModule } from '@/api/sms';
import usePagination from '@/hooks/usePagination';
import { tableDataSchemas, PLATFORM_TYPE, TEMPLATE_TYPE, TEMPLATE_STATUS, templateStatusOptions, templateTypeOptions, formSchemas, yunFormSchemas, contentFormSchemas, clFormSchemas } from './config';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const appId = ref(route.params.appId);
    const tableData = ref([]);
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    // loading效果
    const loading = ref(false);

    // 模板名称
    const templateName = ref('');
    // 模板类型
    const templateType = ref('');
    // 模板状态
    const templateStatus = ref('');
    const handleTemplateStatusChange = e => {
      templateStatus.value = e;
    };
    const handleTemplateTypeChange = e => {
      templateType.value = e;
    };

    /**
     * 获取短信接入方密钥分页
     */
    const getData = async () => {
      loading.value = true;
      const res = await getSmsTemplatePage({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        appId: appId.value,
        templateName: templateName.value,
        templateType: templateType.value,
        templateStatus: templateStatus.value
      });
      tableData.value = res.records;
      setCurrentPage(res.current);
      setTotal(res.total);
      loading.value = false;
    };
    getData();

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };
    const addVisible = ref(false);
    const finalFormSchemas = ref([]);
    const handleAddRow = () => {
      finalFormSchemas.value = formSchemas;
      addVisible.value = true;
    };
    const current = ref(null);
    const handleUpdateTemplate = row => {
      current.value = row;
      finalFormSchemas.value = formSchemas;
      addVisible.value = true;
    };
    const handleUpdateTemplateContent = row => {
      current.value = row;
      finalFormSchemas.value = contentFormSchemas;
      addVisible.value = true;
    };
    const clearCurrent = () => {
      current.value = null;
    };
    const handleChangeFormData = data => {
      // eslint-disable-next-line
      if (data.platform == '3') {
        setTimeout(() => {
          if (!current.value) {
            finalFormSchemas.value = yunFormSchemas;
          }
        });
        // eslint-disable-next-line
      } else if (data.platform == '2') {
        // 阿里云
        setTimeout(() => {
          if (!current.value) {
            finalFormSchemas.value = clFormSchemas;
          }
        });
      } else {
        setTimeout(() => {
          if (!current.value) {
            finalFormSchemas.value = formSchemas;
          }
        });
      }
    };
    const handleDel = row => {
      ElMessageBox.confirm('是否删除?', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delSmsTemplate(row);
        await getData();
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      });
    };
    const router = useRouter();
    const handleJumpSmsTemplateInfo = row => {
      router.push(`/operation/smsSecretManage/moduleDetail/${row.id}`);
    };

    /** 查看审核状态 */
    const handleSearchStatus = async row => {
      const res = await querySmsTemplateAuditStatus(row);
      if (res.templateStatus === 0) {
        ElMessage({
          type: 'info',
          message: '审核中'
        });
      } else if (res.templateStatus === 1) {
        ElMessage({
          type: 'success',
          message: '审核通过'
        });
      } else if (res.templateStatus === 2) {
        ElMessage({
          type: 'error',
          message: '审核不通过：' + res.reason
        });
      }
      tableData.value = tableData.value.map(item => {
        if (item.id === res.id) {
          return res;
        } else {
          return item;
        }
      });
    };

    /** 同步模板 */
    const handleAsyncModule = async () => {
      await asyncModule(appId.value);
      currentPage.value = 1;
      getData();
      ElMessage({
        type: 'success',
        message: '同步成功'
      });
    };
    const handleRefreshActivity = () => {
      currentPage.value = 1;
      templateStatus.value = '';
      templateType.value = '';
      templateName.value = '';
      getData();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          modelValue: templateName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => templateName.value = $event),
          placeholder: "请输入第三方平台模板名称",
          style: {
            "width": "300px"
          }
        }, null, 8, ["modelValue"]), _hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_select, {
          modelValue: templateStatus.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => templateStatus.value = $event),
          class: "m-2",
          placeholder: "选择模板审核状态",
          onChange: handleTemplateStatusChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateStatusOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_select, {
          modelValue: templateType.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => templateType.value = $event),
          class: "m-2",
          placeholder: "选择模板类型",
          onChange: handleTemplateTypeChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateTypeOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefreshActivity
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          type: "success",
          onClick: handleAsyncModule
        }, {
          default: _withCtx(() => [_createTextVNode(" 同步模板 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddRow
        }, {
          default: _withCtx(() => [_createTextVNode(" 申请模板 ")]),
          _: 1
        })])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableDataSchemas), (item, index) => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: item.label,
              "min-width": item.minWidth
            }, {
              default: _withCtx(({
                row
              }) => [item.prop === 'platform' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(PLATFORM_TYPE)[row[item.prop]]), 1)) : item.prop === 'templateType' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_tag, {
                type: row[item.prop] === 1 ? 'success' : row[item.prop] === 2 ? 'info' : ''
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(TEMPLATE_TYPE)[row[item.prop]]), 1)]),
                _: 2
              }, 1032, ["type"])])) : item.prop === 'templateStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_tag, {
                type: row[item.prop] === 1 ? 'success' : row[item.prop] === 2 || row[item.prop] === 4 ? 'info' : ''
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(TEMPLATE_STATUS)[row[item.prop]]), 1)]),
                _: 2
              }, 1032, ["type"])])) : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(row[item.prop]), 1))]),
              _: 2
            }, 1032, ["label", "min-width"]);
          }), 128)), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "400"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "success",
              size: "small",
              onClick: $event => handleJumpSmsTemplateInfo(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 详情 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "info",
              size: "small",
              onClick: $event => handleSearchStatus(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 查看审核状态 ")]),
              _: 2
            }, 1032, ["onClick"]), row.templateStatus === 2 || row.templateStatus === 4 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              onClick: $event => handleUpdateTemplate(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), row.templateStatus === 1 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              size: "small",
              onClick: $event => handleUpdateTemplateContent(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 版本内容校验 ")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => handleDel(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total,  prev, pager, next, jumper",
          style: {
            "margin-top": "10px"
          }
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), addVisible.value ? (_openBlock(), _createBlock(_unref(SmsModule), {
        key: 0,
        modelValue: addVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => addVisible.value = $event),
        model: current.value,
        onRefreshData: getData,
        onClearModel: clearCurrent,
        onChangeFormData: handleChangeFormData,
        appId: appId.value,
        formSchemas: finalFormSchemas.value
      }, null, 8, ["modelValue", "model", "appId", "formSchemas"])) : _createCommentVNode("", true)]);
    };
  }
};